import { dataFetcher } from 'core/services/requestHandler';   

const getExpenseDetails = async (data = {}, config = {}, path) => {
  return dataFetcher('expenses/'+ path, data, {...config});
};

const getExpensesByDate = async (data = {}, config = {},) => {
  return dataFetcher('expenses', data, {...config});
};

const deleteExpense = async (data = {}, config = {}, path) => {
  return dataFetcher('expenses/delete/'+path, data, {...config});
};

const saveExpense = async (data = {}, config = {}) => {
  return dataFetcher('expenses/save', data, {method: 'POST', ...config});
};

const getExpenseTypes = async (data = {}, config = {}) => {
  return dataFetcher('expenses/types', data, {...config});
};

export { getExpensesByDate, getExpenseDetails, saveExpense, deleteExpense, getExpenseTypes };
